package com.neurobs.js.controller

import com.neurobs.js.dom.{Grid, RecordTableView}
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.Grid._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.view.Button
import org.scalajs.dom.raw.HTMLElement

import scala.concurrent.ExecutionContext.Implicits.global
import scala.concurrent.Future

abstract class AdminListAdapter[A] {
	def title: String

	def itemName: String

	def supportRefresh: Boolean = true

	def supportClose: Boolean = true

	def columnHeaders: Seq[RecordTableView.ColumnHeader]

	def itemRow(a: A, delegate: Option[AdminPanelDelegate], controller: AdminListController[A]): Seq[RecordTableView.CellContent]

	val create: Option[(AdminListController[A]) => Unit]

	def get(): Future[Either[String, Seq[A]]]

	def filter(s: Seq[A]): Seq[A] = s

	def customContent: Option[HTMLElement] = None

	var refresh: () => Unit = () => Unit

	var refreshFilter: () => Unit = () => Unit
}

class AdminListView (grid: Grid, columns: Seq[RecordTableView.ColumnHeader], showCreateButton: Boolean, itemName: String, customContent: Option[HTMLElement] = None) {

	val table = new RecordTableView(columns)

	private val createButtonDom = makeButton(caption = s"Create New $itemName")
	def createButton: Button = createButtonDom

	grid.addRow(table.container)
	if (showCreateButton) grid.addRow(createButtonDom)
	if (customContent.isDefined) grid.addRow(customContent.get)
}

class AdminListController[A] (adapter: AdminListAdapter[A]) extends BasicAdminPanelController(title = adapter.title, showRefresh = adapter.supportRefresh, showClose = adapter.supportClose) {

	private val view = new AdminListView(grid, adapter.columnHeaders, adapter.create.isDefined, adapter.itemName, adapter.customContent)
	private var items: Option[Seq[A]] = None

	private def filterAndDisplay(): Unit = {
		val filteredItems = adapter.filter(items.getOrElse(Seq.empty))
		view.table.setContents[A](filteredItems, adapter.itemRow(_, delegate, controller = this))
	}

	def getList(): Unit = {
		refreshLink.setActive(false)
		adapter.get map { res =>
			refreshLink.setActive(true)
			res match {
				case Left(error) => setError(error)
				case Right(items) =>
					setError("")
					this.items = Some(items)
					filterAndDisplay()
			}
		}
	}

	override def refresh(): Unit = getList()

	adapter.create.foreach(h => view.createButton.setHandler(() => h(this)))
	adapter.refresh = () => getList()
	adapter.refreshFilter = () => filterAndDisplay()
	getList()
}
